import React from 'react'
import Hero from './components/Hero'
import WhatWeDo from './components/WhatWeDo'
import FeaturedWorks from './components/FeaturedWorks'
import Reviews from './components/Reviews'
// import Team from "../../components/reuseables/Team"
import Client from '../../components/reuseables/Client'
import Footer from '../../components/reuseables/Footer'

function HomePage() {
		return (
			<div>
				<Hero />
				 <WhatWeDo /> 
				 <FeaturedWorks /> 
				<Client />
				{/* <Team/> */}
				<Reviews />
				<Footer/>
			</div>
		)
}

export default HomePage